import {useSessionStore} from "@/stores/session";

export class EsquireClient {
  private baseUrl = process.env.VUE_APP_ESQUIRE_HOST;

  private defaultHeaders = {
    Accept: "application/json"
  } as {
    Accept: string,
    Authorization: string
  };

  public getBaseUrl(){
    return this.baseUrl;
  }
  public async fetch(createUrl: (baseUrl: string) => URL, options: RequestInit = {}) {
    const headers = {
      ...this.defaultHeaders,
      ...options.headers as Record<string, string>
    };

    const fetchOptions = {
      ...options,
      headers
    };

    const url = createUrl(this.baseUrl);

    return fetch(url.toString(), fetchOptions);
  }

  public async logOutIfForbidden(responseStatus: number) {
    if (responseStatus === 403) {
      await this.logOut();
    }
  }

  public async fetchUrlFromSession(key: string): Promise<string> {
    const session = useSessionStore();
    const url: string | null = session.urlFor(key);
    if (!url) {
      await this.logOut();
      throw new Error(`Route "${key}" not found`);
    }
    return url;
  }


  public async logOut() {
    const session = useSessionStore();
    await session.reAuth(true);
  }



}

export default new EsquireClient();
